import { getToApi, putToApi, postToApi } from './axios';

/**
 * Autoservicio del titular sobre sus propios datos (Ley 21.719, sub-proyecto C).
 *
 * No hay ningún id en estas rutas a propósito: el titular sale del token. Si alguna
 * vez aparece un `/me/:id`, es un bug de seguridad.
 */

// getToApi ya devuelve result.data: no hay que volver a desenvolver.
export const getMisDatos = () => getToApi('/me');

// Solo acepta fullname y email. El backend rechaza con 400 si el body trae rut, type,
// active, tenantId, password o id — el RUT identifica registros regulatorios.
export const actualizarMisDatos = (body) => putToApi('/me', body).then((r) => r.data);

// Los tres derechos que el titular NO puede ejercer solo: hay que evaluar si existe
// obligación legal de conservar. El backend rechaza los otros tres tipos con 400,
// porque acceso/rectificación/portabilidad se resuelven en esta misma pantalla.
export const TIPOS_SOLICITUD_AUTOSERVICIO = ['supresion', 'oposicion', 'bloqueo'];

export const crearMiSolicitud = (body) => postToApi('/me/solicitudes', body).then((r) => r.data);

/**
 * Portabilidad. El endpoint responde JSON (no un binario) y manda Content-Disposition,
 * pero como exige el header Authorization un <a href> pelado no sirve: hay que pedirlo
 * y armar el Blob a mano.
 */
export const descargarMisDatos = async () => {
  const blob = await getToApi('/me/export', { responseType: 'blob' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'mis-datos.json';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
